import { jsx } from 'react/jsx-runtime';
import 'tslib';
import '@teko-builder/types/pb';
import { a as isMobile } from '../../text-21866551.js';
import { D as DateTimePickerMobile, a as DateTimePickerDesktop } from '../../DateTimePickerMobile-749dc497.js';
import 'ua-parser-js';
import 'color-name';
import '@emotion/react';
import 'rc-picker';
import 'rc-picker/lib/generate/dayjs';
import 'rc-picker/lib/locale/vi_VN';
import '@teko-builder/icons';
import '@emotion/styled';
import 'dayjs';
import 'dayjs/locale/vi';
import 'react';
import '../../InputNumber-7d93e963.js';
import 'rc-input-number';
import 'dayjs/plugin/customParseFormat';

const DateTimePicker = (props) => {
    if (isMobile) {
        return jsx(DateTimePickerMobile, Object.assign({}, props));
    }
    return jsx(DateTimePickerDesktop, Object.assign({}, props));
};

export { DateTimePicker };
